"use client";

import { Mail, Phone, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliancesupportcontact() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const grid = useRevealOnScroll<HTMLDivElement>();
  const footer = useRevealOnScroll<HTMLDivElement>();
  const channels = [];
  return <section data-section-id="855" id="compliancesupportcontact" className="bg-background text-foreground">
      <div className="mx-auto max-w-7xl px-6 py-20 sm:py-24 lg:px-8 lg:py-28">
        {}
        <div ref={header.ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs sm:text-sm tracking-[0.25em] uppercase mb-6 text-primary">
            [ CONNECT WITH BPV ]
          </p>
          <h2 className="font-serif font-default text-foreground leading-[1.05]" style={{
          fontSize: "clamp(2.5rem, 5vw, 4rem)"
        }}>
            Ready to{" "}
            <span className="italic text-primary-foreground">
              maximize value?
            </span>
          </h2>
          <p className="mt-6 font-sans text-base sm:text-lg leading-relaxed text-muted-foreground">
            Our partners are available to discuss your business legacy, valuation, and strategic exit options in complete confidence.
          </p>
        </div>

        {}
        <div ref={grid.ref} className={`mt-16 sm:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-700 ease-out delay-150 ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {channels.map((channel, i) => {
          const Icon = channel.icon;
          const isEmergency = channel.type === "emergency";
          return <div key={channel.type} data-index={i} className={`group relative flex flex-col rounded-lg p-10 lg:p-12 transition-all duration-300 hover:-translate-y-1 shadow-md ${isEmergency ? "bg-sidebar text-sidebar-foreground" : "border border-border bg-card"}`}>
                {}
                <div className="mb-8">
                  <Icon className="h-12 w-12 text-primary" strokeWidth={1.25} aria-hidden="true" />
                </div>

                {}
                <p className="font-mono text-xs tracking-[0.2em] uppercase mb-5 text-muted-foreground">
                  {channel.label}
                </p>

                {}
                <h3 className="font-serif font-default text-2xl sm:text-[1.6rem] leading-tight mb-6 text-foreground">
                  {channel.heading}
                </h3>

                {}
                <Link to={channel.contactHref} className="font-serif font-default leading-tight break-words transition-opacity hover:opacity-80 text-primary" style={{
              fontSize: channel.type === "email" ? "1.5rem" : "2rem"
            }}>
                  {channel.contact}
                </Link>

                {}
                <div className="mt-8 mb-5 h-px w-full bg-border" />

                {}
                <p className="font-sans text-sm leading-relaxed text-muted-foreground">
                  {channel.hours}
                </p>

                {}
                <span className="pointer-events-none absolute bottom-0 left-10 right-10 h-px origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100 bg-primary" aria-hidden="true" />
              </div>;
        })}
        </div>

        {}
        <div ref={footer.ref} className={`mt-16 sm:mt-20 flex items-center justify-center gap-3 transition-all duration-700 ease-out delay-300 ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75 bg-chart-2" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-lg bg-chart-2" />
          </span>
          <p className="font-serif font-default italic text-lg sm:text-xl text-foreground">
            Confidentiality is our foundation.
          </p>
        </div>
      </div>
    </section>;
}